import {
  dealCarDatas
} from '@/cllib/sys_lib'

import {
  carGetCarList,
  carAddCar,
  carUpdateCar,
  carDeleteCar,
  carUpdateCarBin
} from '@/api/api'

const state = {
  carList: [],
  carTotal: 0
}

const getters = {
  carList: state => state.carList,
  carTotal: state => state.carTotal
}

const actions = {
  loadCarList ({ dispatch }, parm) {
    return carGetCarList(parm).then((data) => {
      dispatch('setCarList', dealCarDatas(data))
    })
  },
  addCar ({ commit }, parm) {
    return carAddCar(parm)
  },
  updateCar ({ commit }, parm) {
    return carUpdateCar(parm)
  },
  updateCarBin ({ commit }, {carId, parm}) {
    return carUpdateCarBin(carId, parm)
  },
  delCar ({ commit }, gasId) {
    return carDeleteCar(gasId)
  },
  setCarList ({ commit }, data) {
    commit('setCarList', data)
  },
  setCarTotal ({ commit }, data) {
    commit('setCarTotal', data)
  }
}

const mutations = {
  setCarList (state, data) {
    state.carList = data
  },
  setCarTotal (state, data) {
    state.carTotal = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base_data/car.js